import { jsx as _jsx } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { useEffect } from "react";
import { Box } from "@mui/material";
export function PyodideTerminal({ backgroundColor = "#202020", }) {
    useEffect(() => {
        // @ts-ignore
        window.console_ready();
    }, []);
    // const toggleConsole = () => {
    //   setActivePanels({
    //     ...activePanels,
    //     console: !activePanels.console,
    //   });
    // };
    // useEffect(() => {
    //   //@ts-ignore
    //   const term = window.term;
    //   if (!activePanels.console && term) {
    //     term.scroll_to_bottom();
    //   }
    // }, [activePanels.console]);
    return (_jsx(Box, { id: "term_demo", sx: {
            background: backgroundColor,
            height: "100%",
        } }));
}
